import { FC, ReactNode } from 'react';
import { ButtonColorTypes, ButtonShape, ButtonSizes } from '~src/shared/buttons/basicButtons/BaseButton.sc';
import PrimaryButtonLoading from '~src/shared/buttons/loadingButtons/PrimaryButtonLoading';

interface Props {
  isLoading: boolean;
  children: ReactNode;
  onClick?: () => unknown;
}

const LoginButton: FC<Props> = ({isLoading, children, onClick}) => {
  return <PrimaryButtonLoading
    isLoading={isLoading}
    $buttonSize={ButtonSizes.MediumWide}
    $buttonColor={ButtonColorTypes.LightBlue}
    $buttonShape={ButtonShape.Oval}
    onClick={onClick}
  >
    {children}
  </PrimaryButtonLoading>
};

export default LoginButton;
